const C = {
  name: "DocumentPerson",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 8C11.7909 8 10 9.79086 10 12C10 14.2091 11.7909 16 14 16C16.2091 16 18 14.2091 18 12C18 9.79086 16.2091 8 14 8ZM12 12C12 10.8954 12.8954 10 14 10C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14C12.8954 14 12 13.1046 12 12Z" fill="currentColor"/>
<path d="M4 1C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H5V20C5 21.6569 6.34315 23 8 23H20C21.6569 23 23 21.6569 23 20V8C23 6.34315 21.6569 5 20 5H15V4C15 2.34315 13.6569 1 12 1H4ZM13 5H8C6.34315 5 5 6.34315 5 8V13H4C3.44772 13 3 12.5523 3 12V4C3 3.44772 3.44772 3 4 3H12C12.5523 3 13 3.44772 13 4V5ZM7 20V8C7 7.44772 7.44772 7 8 7H20C20.5523 7 21 7.44772 21 8V20C21 20.5523 20.5523 21 20 21C20 18.7909 18.2091 17 16 17H12C9.79086 17 8 18.7909 8 21C7.44772 21 7 20.5523 7 20ZM16 19C17.1046 19 18 19.8954 18 21H10C10 19.8954 10.8954 19 12 19H16Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as DocumentPerson
};
